import {defineStore} from 'pinia';
import {ModuleFixedAssetCategory} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import FixedAssetCategoryAPI from '@/apis/di/fixedAssetCategoryAPI';

const fixedAssetCategoryStore = new BaseDictionaryStore(FixedAssetCategoryAPI);

export const useFixedAssetCategory = defineStore(ModuleFixedAssetCategory, {
  state: () => ({
    ...fixedAssetCategoryStore.state,
    _config: {
      key: 'fixed_asset_category_id',
      code: 'fixed_asset_category_code',
      table: 'di_fixed_asset_category',
      moduleName: 'Loại TSCĐ',
      quickFollow: 'active',
      isTree: true,
      defaultSort: 'fixed_asset_category_code',
    },
    moduleName: 'fixedAssetCategory',
  }),
  actions: {...fixedAssetCategoryStore.action},
  getters: {
    ...fixedAssetCategoryStore.getters,
  },
});
